<template>
  <div class="boxwrap-items">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'boxwrap-items'
}
</script>
